// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b340e894","246":"5de62c24","287":"982368ea","326":"4bfb6644","394":"d77dc392","435":"80941233","453":"2719c8a6","552":"2f327c2d","571":"848fd26b","603":"72c2abd5","646":"4199b928","671":"6047b122","880":"8c8314e8","888":"756430c4","965":"95815ea6"}[chunkId] + ".chunk.js";
};